<template>
  <div>
    <section id="home" class="video-hero home-top">
      <div class="overlay top-bk"></div>
      <div class="display-t text-center mt-5 mt-md-0">
        <div class="display-tc">
          <div class="container">
            <div class="col-md-12 col-md-offset-0">
              <div class="animate-box main-top-area">
                <div class="d-flex row">
                  <!-- <div v-html="$t('site.home.subtitle')" class="col-md-6"></div> -->
                  <div class="col-md-6 pt-5 pt-md-0 d-flex align-items-center">
                    <div>
                      <h3 class="text-light text-left">
                        {{ $t("site.home.title") }}
                      </h3>

                      <p
												class="mt-3 text-left"
                        v-html="$t('site.home.subtitle')"
                      ></p>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <img
                      src="@/assets/img/process.svg"
                      class="img-tasks img-mobile"
                      alt="Process Management "
                      width="380px"
                    />
                  </div>
                </div>
                <p>
                  <router-link
                    :to="{ name: 'create_account' }"
                    class="btn mt-4 mb-4 btn-primary btn-lg btn-custom"
                  >
                    <i class="icon-plus2"></i>
                    {{ $t("site.register.btn_create_your_account") }}
                  </router-link>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- <div class="pb-1"> -->
    <!-- <carousel :autoplay="true" :nav="false"  :items="1" wid class="carousel-top">

				<img src="@/assets/img/screen-dashboard.jpg">
				<img src="@/assets/img/screen-process-form.jpg">
				<img src="@/assets/img/screen-process-kanban.jpg">
				<img src="@/assets/img/screen-profile.jpg">
				<img src="@/assets/img/screen-profile-2.jpg">
				<img src="@/assets/img/screen-financial-extract-1.jpg">

		</carousel> -->
    <!-- </div> -->
    <div class="colorlib-services colorlib-bg-white mt-3">
      <div class="container">
        <div class="row">
          <div class="col-md-4 text-center animate-box">
            <div class="services">
              <span class="icon">
                <i class="icon-browser"></i>
              </span>
              <div class="desc">
                <h2>{{ $tc("process", 2) }}</h2>
                <div v-html="$t('site.home.features.process.desc')"></div>
              </div>
            </div>
          </div>
          <div class="col-md-4 text-center animate-box">
            <div class="services">
              <span class="icon">
                <i class="icon-documents"></i>
              </span>
              <div class="desc">
                <h2>{{ $tc("profile_and_curriculum", 2) }}</h2>
                <div
                  v-html="$t('site.home.features.profile_and_cvs.desc')"
                ></div>
              </div>
            </div>
          </div>
          <div class="col-md-4 text-center animate-box">
            <div class="services">
              <span class="icon">
                <i class="icon-lightbulb"></i>
              </span>
              <div class="desc">
                <h2>{{ $tc("custom_features", 2) }}</h2>
                <div
                  v-html="$t('site.home.features.custom_features.desc')"
                ></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div id="colorlib-counter" class="colorlib-counters">
      <div class="overlay"></div>
      <div class="container">
        <div class="row">
          <div class="col-md-4 col-sm-4 text-center animate-box">
            <div class="counter-entry">
              <span class="icon"><i class="flaticon-ribbon"></i></span>
              <div class="desc">
                <span
                  class="colorlib-counter js-counter"
                  data-from="0"
                  data-to="1500"
                  data-speed="5000"
                  data-refresh-interval="50"
                ></span>
                <span class="colorlib-counter-label">
                  {{ $tc("online_system", 1) }}
                </span>
              </div>
            </div>
          </div>
          <div class="col-md-4 col-sm-4 text-center animate-box">
            <div class="counter-entry">
              <span class="icon"><i class="flaticon-church"></i></span>
              <div class="desc">
                <span
                  class="colorlib-counter js-counter"
                  data-from="0"
                  data-to="500"
                  data-speed="5000"
                  data-refresh-interval="50"
                ></span>
                <span class="colorlib-counter-label">
                  {{ $t("process_and_profile_configurator") }}
                </span>
              </div>
            </div>
          </div>
          <div class="col-md-4 col-sm-4 text-center animate-box">
            <div class="counter-entry">
              <span class="icon"><i class="flaticon-dove"></i></span>
              <div class="desc">
                <span
                  class="colorlib-counter js-counter"
                  data-from="0"
                  data-to="1200"
                  data-speed="5000"
                  data-refresh-interval="50"
                ></span>
                <span class="colorlib-counter-label">
                  {{ $t("free_support_and_training") }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="colorlib-work-featured colorlib-bg-white">
      <div class="container">
        <div class="row mobile-wrap">
          <div class="col-md-5 animate-box">
            <div class="desc">
              <h2>
                {{ $t("process_management") }}
              </h2>
              <div class="features">
                <div
                  class="f-desc_ d-flex"
                  v-html="$t('site.features.processes.pre_registred.list')"
                ></div>
              </div>
              <router-link
                :to="{ name: 'create_account' }"
                class="btn btn-primary btn-outline with-arrow"
              >
                {{ $t("action.create_free_account") }}
                <i class="icon-arrow-right3"></i>
              </router-link>
            </div>
          </div>
          <div class="col-md-7 animate-box">
            <img
              data-v-9b94d8ba=""
              src="@/assets/img/kanban.png"
              alt="Kanban board"
              width="100%"
              class="w-100 hand shadow"
              data-v-718b9009=""
              style="
                opacity: 1;
                transform: translate3d(0px, 0px, 0px);
                transition: all 0.2s ease-in 0s;
              "
            />
          </div>
        </div>
        <div class="row mobile-wrap">
          <div class="col-md-7 animate-box">
            <img
              src="@/assets/img/profile_compare.jpg"
              width="100%"
              alt="Compare profiles"
            />
          </div>
          <div class="col-md-5 animate-box">
            <div class="desc">
              <h2>
                {{ $tc("compare_profile.label", 2) }}
              </h2>
              <div class="features">
                <div class="f-desc_">
                  <p class="mt-2">
                    {{ $t("compare_profile.desc") }}
                  </p>
                </div>
              </div>
              <router-link
                :to="{ name: 'create_account' }"
                class="btn btn-primary btn-outline with-arrow"
              >
                {{ $t("action.create_free_account") }}
                <i class="icon-arrow-right3"></i>
              </router-link>
            </div>
          </div>
        </div>
        <div class="row mobile-wrap">
          <div class="col-md-5 animate-box">
            <div class="desc">
              <h2>{{ $tc("profile_status.label", 2) }}</h2>
              <div class="features">
                <div class="f-desc_">
                  <p class="mt-2">
                    {{ $t("profile_status.desc") }}
                  </p>
                </div>
              </div>
              <p>
                <router-link
                  :to="{ name: 'create_account' }"
                  class="btn btn-primary btn-outline with-arrow"
                >
                  {{ $t("action.create_free_account") }}
                  <i class="icon-arrow-right3"></i>
                </router-link>
              </p>
            </div>
          </div>
          <div class="col-md-7 animate-box">
            <img
              src="@/assets/img/profile_status.jpg"
              width="100%"
              alt="Profile Status"
            />
          </div>
        </div>
      </div>
    </div>

    <PlansBoxs :is-main="false" class="mt-5" />
  </div>
</template>

<script>
// import carousel from 'vue-owl-carousel'
import PlansBoxs from "@/components/pages/Plans/PlansBoxs";

export default {
  name: "AppTemplate",
  components: {
    // carousel,
    PlansBoxs,
  },
  computed: {
    selectedCategoryId() {
      return this.filters.category_id;
    },
  },
  mounted() {
    // this.$helpers.ga.openPage('home');
    this.$helpers.scrollTop(0);
  },
  methods: {
    changeCategory(id) {
      this.setFilterCategoryId({ id: id });
      console.log(id);
    },
  },
};
</script>

<style lang="scss">
@import 'src/assets/css/patterns.scss';

.text-shadow {
  text-shadow: 0px 1px 0px rgba(80, 80, 80, 1);
}

.text-light {
  color: red;
}

.animate-box.main-top-area {
  h2,
  h1 {
    color: white;
  }
  p {
    font-size: 20px !important;
  }
}

.img-tasks {

	width: 380px;

	@media screen and (max-width: $screen-sm) {
		width: 300px;
  }
}

// .carousel-top {
//   margin: 0 auto;
//   margin-bottom: 20px;
//   /* display: flex; */
//   max-width: 1260px;
//   margin-top: -50px;
//   margin-top: -0em !important;

//   .owl-carousel .owl-stage-outer {
//     -webkit-box-shadow: 0px 9px 24px 1px rgba(0, 0, 0, 0.37);
//     -moz-box-shadow: 0px 9px 24px 1px rgba(0, 0, 0, 0.37);
//     box-shadow: 0px 9px 24px 1px rgba(0, 0, 0, 0.37);
//   }

//   @media screen and (min-width: 769px) {
//     margin-top: -10em !important;
//   }
// }

.player {
  opacity: 0.06;
}

.video-hero.home-top,
.player {
  height: 500px !important;

  @media screen and (max-width: 769px) {
    height: 750px !important;
  }

  .overlay.top-bk {
    // border: 1px solid red;
    // background-image: url(/assets/images/cover_img_1.jpg) !important;
    background-size: cover;
    background-position: center center;
    background-attachment: fixed;
  }
}
</style>